/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-08-19 17:08:11
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-01 11:34:21
 */
import axios from 'axios'
// import { GroupInfo } from '../../../modules/receiveEntity'
import { sendmessageprivate, sendmessagepublic } from '../../../../service/loginaction'

// const cglobal: any = global

export async function createGroup(group) {
    // debugger
    return new Promise((resolve, reject) => {
        axios.post(`${window.serviceUrl.chat}/group/create`, group).then(res => {
            resolve(res.data)
        }).catch(e => {
            reject(e)
        })
    })
}


export async function sendFile(roomId,file, type) {
    let data = new FormData()
    data.append("file", file)
    return new Promise((resolve, reject) => {
        axios.post(`${window.serviceUrl.ossUpload}/gateway/api/oss-support/oss/upload`, data, {
            headers: {
                "Content-Type": "multipart/form-data;"
            }
        }).then(res => {
            if (res.status === 200) {
                let content = {
                    url: window.serviceUrl.fileServerImg + "/" + res.data.payload,
                    fileName: file.name
                }
                let contentStr = JSON.stringify(content)
                //群聊
                if (roomId.indexOf('group') !==-1) {
                    sendmessagepublic({ url: roomId, content:content, type })
                }
                // 私聊 
                else if (roomId.indexOf('private') !==-1) {
                    sendmessageprivate({ targetuserId:roomId.substring(9),content:content, type })
                }
                resolve("")
            }
        }).catch(e => { console.error(e); reject(e) })
    })
}